import {
  REQUEST_DATA_ERROR_ANALYSIS,
  REQUEST_MONTH_DATA,
  REQUEST_MONTH_DATA_BLOCKED,
  SET_BASE_REQUEST_PATH,
  SET_JHA_TOKEN,
  SET_PRICE_SOURCE_ID,
  SET_PROVIDER_DATA,
  SET_VIEW_ID,
} from '../helpers/constants/actionsConstants';

import type { BrowseDataAction } from '../actions/types';
import type { BrowserDataState } from '../selectors/types';

const REQUEST_MONTH_DATA_STARTED: `${typeof REQUEST_MONTH_DATA}_STARTED` = `${REQUEST_MONTH_DATA}_STARTED`;
const REQUEST_MONTH_DATA_SUCCEEDED: `${typeof REQUEST_MONTH_DATA}_SUCCEEDED` = `${REQUEST_MONTH_DATA}_SUCCEEDED`;
const REQUEST_MONTH_DATA_FAILED: `${typeof REQUEST_MONTH_DATA}_FAILED` = `${REQUEST_MONTH_DATA}_FAILED`;

const initialState: BrowserDataState = {
  initialLoad: true,
  isFetching: false,
  failed: false,
  baseUrl: '',
  priceSourceId: 'unspecified-unspecified',
  priceProviderData: {
    previousCurrency: '',
    previousPrice: 0,
    previousProvider: '',
  },
  viewId: undefined,
};

const reducer = (
  state: BrowserDataState = initialState,
  action: BrowseDataAction,
): BrowserDataState => {
  switch (action.type) {
    case REQUEST_MONTH_DATA_STARTED:
      return {
        ...state,
        isFetching: true,
        failed: false,
        initialLoad: false,
      };

    case REQUEST_MONTH_DATA_SUCCEEDED:
    case REQUEST_MONTH_DATA_BLOCKED:
      return {
        ...state,
        isFetching: false,
      };

    case REQUEST_MONTH_DATA_FAILED:
    case REQUEST_DATA_ERROR_ANALYSIS:
      return {
        ...state,
        isFetching: false,
        failed: true,
      };

    case SET_BASE_REQUEST_PATH:
      return {
        ...state,
        baseUrl: action.payload,
      };

    case SET_PRICE_SOURCE_ID:
      return {
        ...state,
        priceSourceId: action.payload,
      };

    case SET_PROVIDER_DATA:
      return {
        ...state,
        priceProviderData: action.payload,
      };

    case SET_VIEW_ID:
      return {
        ...state,
        viewId: action.payload,
      };

    case SET_JHA_TOKEN:
      return {
        ...state,
        jhaToken: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
